import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Col, Row } from "react-bootstrap";
import "./ButtonComponent.css";
import { useHistory } from "react-router";
import { confirmDialog } from "primereact/confirmdialog";
import ComponentLabel from "../ComponentLabel";
import { UseFormGetValues } from "react-hook-form";
import {
  getValueControl,
  getValueInTemplate,
} from "../../../Helper/RequestScreenHelper";
import CryptoJS from "crypto-js";
import { report } from "../../../constants/util";
interface Props {
  template: any;
  data: any;
  col?: any;
  rowIdx: number;
  colIdx: number;
  onChangeEditForm?: (dataRequest: any, rowIdx: number, colIdx: number) => void;
  colText?: number;
  colAction?: number;
  documentNo: any;
  renderInTable?: boolean;
  errorValid?: any;
  statusMemoDetail?: boolean;
  name: any;
  control: any;
  canEditDoc: boolean;
  getValues: UseFormGetValues<{
    items: any;
  }>;
}
export default function ButtonComponent(props: Props) {
  const [url, setUrl] = useState<string>("");
  const history = useHistory();
  const tinyUrl = localStorage.getItem("tinyUrl");

  useEffect(() => {
    if (props.template.URL) {
      let newUrl: string = props.template.URL;
      newUrl = newUrl.replace("TP", "template");
      if (newUrl.indexOf("/Memo?") !== -1) {
        newUrl = newUrl.replace("/Memo?", "MemoID=0&");
      }
      if (newUrl.startsWith("http")) {
        newUrl = newUrl;
      } else if (!newUrl.startsWith("?")) {
        newUrl = "?" + newUrl;
      }

      if (process.env.NODE_ENV == "development") {
        if (tinyUrl) {
          newUrl = newUrl.replaceAll(
            tinyUrl,
            location.hostname + ":" + location.port
          );
          newUrl = newUrl.replaceAll("https", "http");
        }
      }

      setUrl(newUrl);
    }
  }, []);

  return (
    <>
      <ComponentLabel
        renderInTable={props.renderInTable}
        col={props.col}
        colText={props.colText}
        rowIdx={props.rowIdx}
        colIdx={props.rowIdx}
        template={props.template}
      />
      <Col
        sm={props.col === undefined ? 12 : 12}
        md={props.col === undefined ? props.colAction : 12}
        xs={props.col === undefined ? 12 : 12}
        xl={props.col === undefined ? props.colAction : 12}
        className={
          props.renderInTable === undefined ? "padding-controller" : ""
        }
      >
        <div>
          <Button
            label={props.template.alter}
            type={"button"}
            onClick={() => {
              const temp = props.template;
              let str = "";
              if (props.documentNo !== "Auto Generate") {
                let param = "";
                let val = "";
                const allVal = props.getValues();
                temp.attribute?.items?.map((item: any) => {
                  item?.layout?.map((_layout: any) => {
                    if (_layout?.control?.label === "Document No") {
                      val = props.documentNo;
                    } else {
                      const obj = (_layout?.reportFilter || []).map(
                        (filter: {
                          condition: any;
                          labels: any[];
                          FilterParameter: string;
                        }) => {
                          filter.condition = (filter.labels || []).map((label: any) => {
                            return {
                              field: label,
                              value: getValueInTemplate(allVal, label, ""),
                            };
                          });
                          return {
                            condition: filter.condition,
                            FilterParameter: filter.FilterParameter,
                          };
                        }
                      );
                      val = JSON.stringify(obj);
                    }
                    param = _layout?.paramiter?.value;
                  });
                });

                if (param !== "" && val !== "") {
                  if (param === "Document No") {
                    str = "&" + param + "=" + val;
                  } else {
                    console.log(val);

                    str =
                      "?" +
                      param +
                      "=" +
                      CryptoJS.AES.encrypt(val, report).toString();
                  }
                }

                if (url.startsWith("?")) {
                  window.open(`/Request${url + str}`, "_blank", "noreferrer");
                } else {
                  window.open(`${url + str}`, "_blank", "noreferrer");
                }
              } else {
                confirmDialog({
                  message: "กรุณาบันทึกก่อนดำเนินการ",
                  header: "Alert",
                  icon: "pi pi-exclamation-triangle",
                  rejectClassName: "hide-component",
                });
              }
            }}
          />
        </div>
      </Col>
    </>
  );
}
